/* RS Air Filter — carrossel simples (scroll-snap + setas), sem dependências */
(function () {
  function init() {
    document.querySelectorAll('[data-rs-carousel]').forEach(function (c) {
      if (c.dataset.rsBound) return;
      c.dataset.rsBound = '1';
      var track = c.querySelector('[data-rs-track]');
      if (!track) return;
      var prev = c.querySelector('[data-rs-prev]');
      var next = c.querySelector('[data-rs-next]');
      function step() {
        var s = track.querySelector('.rsd-slide');
        return s ? Math.round(s.getBoundingClientRect().width) + 16 : 320;
      }
      if (next) next.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });
      if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    });
  }
  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
